<script>
 export let firstitleh5;
 export let title;
 export let subtitle;
 export let btn1Href;
 export let btn1Text;
 export let btn2Text;
 export let btn2Href;
</script>

<!--style="background-image: url(/img/computer-1209641.jpg);"-->

<section id="bannerhome" class="home-banner theme-after bg-cover" >
    <div class="container">
        <div class="row align-items-center justify-content-center full-screen p-100px-tb sm-p-60px-b">
            <div class="col-lg-12 text-center">
                <h5>{firstitleh5}</h5>
                <h1 class="font-alt">{title}</h1>
                <p>{subtitle}</p>
                <div class="btn-bar m-30px-t">
                    <a class="btn btn-t-white" href="{btn1Href}">{btn1Text}</a>
                    <a class="btn  btn-white shadow-drop-bl-hover " href="{btn2Href}">{btn2Text}</a>
                </div>
            </div> <!-- col -->
        </div> <!-- row -->
    </div>
</section>

<style>
    *,::after,::before{box-sizing:border-box;}
    section{display:block;}
    h1,h5{margin-top:0;margin-bottom:.5rem;}
    p{margin-top:0;margin-bottom:1rem;}
    a{color: #6180fc;text-decoration:none;background-color:transparent;-webkit-text-decoration-skip:objects;}
    h1,h5{margin-bottom:.5rem;font-family:inherit;font-weight:500;line-height:1.2;color:inherit;}
    h1{font-size:2.5rem;}
    h5{font-size:1.25rem;}
    .container{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto;}
    @media (min-width:576px){
        .container{max-width:540px;}
    }
    @media (min-width:768px){
        .container{max-width:720px;}
    }
    @media (min-width:992px){
        .container{max-width:960px;}
    }
    @media (min-width:1200px){
        .container{max-width:1140px;}
    }
    .row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px;}
    .col-lg-12{position:relative;width:100%;min-height:1px;padding-right:15px;padding-left:15px;}
    @media (min-width:992px){
        .col-lg-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%;}
    }
    .btn{display:inline-block;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;}
    @media screen and (prefers-reduced-motion:reduce){
        .btn{transition:none;}
    }
    .btn:focus,.btn:hover{text-decoration:none;}
    .btn:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25);}
    .btn:disabled{opacity:.65;}
    .justify-content-center{-ms-flex-pack:center!important;justify-content:center!important;}
    .align-items-center{-ms-flex-align:center!important;align-items:center!important;}
    .text-center{text-align:center!important;}
    @media print{
        *,::after,::before{text-shadow:none!important;box-shadow:none!important;}
        a:not(.btn){text-decoration:underline;}
        p{orphans:3;widows:3;}
        .container{min-width:992px!important;}
    }
    /*! CSS Used from: http://www.inventheme.com/themeforest/axoma/axoma/static/plugin/themify-icons/themify-icons.css */
    [class^="ti-"]{font-family:'themify';speak:none;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
    .ti-angle-down:before{content:"\e64b";}
    /*! CSS Used from: http://www.inventheme.com/themeforest/axoma/axoma/static/css/style.css */
    .font-alt{font-family:'Nunito', sans-serif;font-weight: bold}
    a{text-decoration:none!important;}
    .btn{font-size:12px;text-transform:uppercase;font-weight:600;letter-spacing:1px;padding:10px 22px;border-radius:5px;border:none;box-shadow:0px 8px 15px rgba(0, 0, 0, 0.1);}
    .btn-t-white{border:1px solid #fff;color:#fff;}
    .btn-t-white:hover{background:#fff;}
    .btn-white{border:1px solid #fff;background:#fff;}
    .full-screen{min-height:100vh;}
    .home-banner{position:relative;z-index:1;overflow:hidden; background: transparent}
    .home-banner:after{content:"";position:absolute;top:0;bottom:0;left:0;right:0;opacity:0.9;z-index:-1;}
    .home-banner h5{color:#fff;font-weight:300;font-size:15px;letter-spacing:3px;text-transform:uppercase;}
    .home-banner h1{font-weight:bold;letter-spacing:6px;text-transform:uppercase;color:#fff;margin:20px 0 20px 0;font-size:40px;}
    .home-banner p{font-size:15px;width:600px;margin:0 auto;color:#fff;font-weight:300;max-width:100%;}
    .home-banner .btn{margin:0 8px;min-width:150px;}
    .home-banner .got-to{width:50px;height:40px;background:#fff;text-align:center;line-height:40px;border-radius:10px 10px 0% 0%;position:absolute;bottom:-10px;left:0;right:0;margin:auto;font-size:18px;}
    .home-banner .got-to a{display:inline-block;vertical-align:top;width:100%;}
    @media (max-width: 767px){
        .home-banner h1{font-size:30px;}
    }
    .bg-cover{-webkit-background-size:cover;-moz-background-size:cover;-ms-background-size:cover;-o-background-size:cover;background-size:cover;}
    .m-30px-t{margin-top:30px;}
    .p-100px-tb{padding-top:100px;padding-bottom:100px;}
    @media (max-width: 767px){
        .sm-p-60px-b{padding-bottom:60px;}
    }
    /*! CSS Used from: http://www.inventheme.com/themeforest/axoma/axoma/static/css/color/default.css */
    ::selection{background-color:#0575E6;color:#fff;}
    ::-moz-selection{background-color:#0575E6;color:#fff;}
    a:hover{color:#0575E6;}
    a,.btn-t-white:hover,.btn-white{color:#0575E6;}
    .theme-after:after{background-image:linear-gradient(to right, rgba(0, 32, 221, 0), rgba(5, 117, 230, 0.75));}
    /*! CSS Used fontfaces */
   </style>